import React from "react";

import PageHeading from "2g-page-heading";

import NotifikaceWidget from "b2b/components/notifikace/NotifikaceWidget";

const notifikace = require("b2b-devel/notifikace.json");

export function NotifikaceExample() {
  return (
    <>
      <PageHeading>NotifikaceWidget</PageHeading>
      <NotifikaceWidget notifikace={notifikace} />
    </>
  );
}

export default React.memo(NotifikaceExample);
